```vue
<template>
  <b-container fluid class="py-4">
    <b-card no-body class="mb-4 shadow-sm rounded-lg">
      <b-card-header class="bg-white border-0 py-3">
        <h3 class="mb-0 font-weight-bold text-dark">Paparan Pengguna</h3>
      </b-card-header>

      <b-card-body class="p-4">
        <b-row>
          <b-col lg="6" class="mb-4">
            <b-form-group label="Nama" label-class="font-weight-bold text-muted">
              <p class="form-control-static text-dark">{{ user.name }}</p>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="mb-4">
            <b-form-group label="No Kad Pengenalan" label-class="font-weight-bold text-muted">
              <p class="form-control-static text-dark">{{ user.icno }}</p>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="mb-4">
            <b-form-group label="Emel" label-class="font-weight-bold text-muted">
              <p class="form-control-static text-dark">{{ user.email }}</p>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="mb-4">
            <b-form-group label="Peranan" label-class="font-weight-bold text-muted">
              <p class="form-control-static text-dark">{{ user.status_entitle }}</p>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="primary"
            class="rounded-pill px-4 py-2 mr-2"
            @click="navigateToEdit(user.id)"
          >
            <i class="fas fa-pencil-alt mr-1"></i> Kemaskini
          </b-button>
          <b-button
            variant="outline-secondary"
            class="rounded-pill px-4 py-2"
            @click="navigateBack"
          >
            <i class="fas fa-arrow-left mr-1"></i> Kembali
          </b-button>
        </div>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios';
import { baseURL } from '../../../services/baseURL';

export default {
  name: 'UserView',
  data() {
    return {
      user: {},
    };
  },
  computed: {
    userlocal() {
      return JSON.parse(localStorage.getItem('user')) || {};
    },
  },
  methods: {
    async getProfile() {
      try {
        const response = await axios.post(
          `${baseURL}/papar_profile.php`,
          { user: { id: this.$route.params.id } },
          { headers: { 'Content-Type': 'application/json' } }
        );
        this.user = response.data[0] || {};
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    },
    navigateToEdit(userId) {
      this.$router.push(`/user/edit/${userId}`);
    },
    navigateBack() {
      this.$router.push('/user');
    },
  },
  created() {
    this.getProfile();
  },
};
</script>

<style scoped>
.card {
  background: #fff;
  border: 1px solid #e9ecef;
}

.card-header {
  background: #f8f9fa;
  color: #343a40;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: 2px solid #dee2e6;
  padding: 1rem;
}

.form-control-static {
  font-size: 0.875rem;
  color: #343a40;
  margin-bottom: 0;
}

.text-dark {
  color: #343a40 !important;
}

.text-muted {
  color: #6c757d !important;
}

.btn-primary,
.btn-outline-secondary {
  font-size: 0.875rem;
  padding: 0.5rem 1.5rem;
}

.rounded-pill {
  border-radius: 50rem !important;
}

h3 {
  font-size: 1.5rem;
}

label {
  font-size: 0.875rem;
}
</style>
```
